import { motion } from "framer-motion";
import { ShieldCheck, Star, MapPin, MessageCircle } from "lucide-react";

/**
 * TrustBar — Princípios aplicados:
 * - Prova social real (avaliações 5,0 no Google, sem inventar contagem).
 * - Autoridade (CRP/SP visível).
 * - Redução de fricção ("primeira conversa sem compromisso").
 * - Framing de disponibilidade (presencial + online) para ampliar público.
 */
const items = [
  {
    icon: Star,
    title: "5,0 ★★★★★",
    text: "Avaliações reais no Google",
    href: "https://www.google.com/search?q=Equilybra+Psicologia+Ipiranga",
  },
  {
    icon: ShieldCheck,
    title: "CRP/SP registrado",
    text: "Equipe com registro no Conselho",
  },
  {
    icon: MessageCircle,
    title: "Primeira conversa sem compromisso",
    text: "Você tira dúvidas antes de agendar",
  },
  {
    icon: MapPin,
    title: "Presencial e online",
    text: "Ipiranga · SP · Brasil todo",
  },
];

const TrustBar = () => {
  return (
    <section aria-label="Motivos para confiar na Equilybra" className="py-8 bg-background border-y border-border/60">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {items.map((it, i) => {
            const Icon = it.icon;
            const inner = (
              <motion.div
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.35, delay: i * 0.05 }}
                className="flex items-start gap-3 p-4 rounded-xl bg-card/70 backdrop-blur border border-border/60 h-full hover:border-primary/40 transition-colors"
              >
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
                  <Icon className="w-5 h-5 text-primary" />
                </div>
                <div className="min-w-0">
                  <div className="font-heading font-semibold text-sm text-foreground leading-tight">
                    {it.title}
                  </div>
                  <div className="text-xs text-muted-foreground mt-0.5 leading-snug">{it.text}</div>
                </div>
              </motion.div>
            );
            return it.href ? (
              <a key={i} href={it.href} target="_blank" rel="noopener noreferrer" className="block">
                {inner}
              </a>
            ) : (
              <div key={i}>{inner}</div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
